import React, { useEffect } from 'react';
import i18n from 'i18n-js';
import Can from 'components/Can';
import Logs from 'components/Logs';
import Title from 'components/Title';
import Layout from 'components/Layout';
import Comments from 'components/Comments';
import { useParams } from 'react-router-dom';
import { Grid, Container } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { vehicleActions } from 'state/modules/vehicles';
import { VehicleTypeDetailsWidget, VehicleTypeImages } from 'components/VehiclesTypes';

const VehicleTypeDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { vehicleType } = useSelector((state) => state.vehicles);

  useEffect(() => {
    if (id) {
      dispatch(vehicleActions.fetchVehicleTypeById(id));
    }
    dispatch(vehicleActions.resetVehicleTypeOnboarding());
  }, [dispatch, id]);

  return (
    <Layout title={i18n.t('vehicle.details_title')}>
      <Container sx={{ margin: 0 }}>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid size={12}>
            <Grid
              container
              rowSpacing={1}
              direction="row"
              justifyContent="space-between"
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid>
                <Title
                  title={`${i18n.t('vehicle_types.vehicle_type')} - ${vehicleType?.year || ''} ${
                    vehicleType?.make || ''
                  } ${vehicleType?.model || ''} ${vehicleType?.powertrain || ''}`}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid size={12}>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
              <Grid size={{ xs: 12, md: 4 }}>
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                  <Grid size={12}>
                    <VehicleTypeDetailsWidget vehicleType={vehicleType} />
                  </Grid>
                  <Grid size={12}>
                    <VehicleTypeImages id={vehicleType?.id} />
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                  <Grid size={12}>
                    <Comments type="vehicle_type" id={parseInt(id)} />
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                  <Grid size={12}>
                    <Can I="read" on="event_log">
                      <Logs
                        targetId={parseInt(id)}
                        targetType="VehicleType"
                        title="Vehicle type logs"
                      />
                    </Can>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default VehicleTypeDetails;
